import { __rest } from "tslib";
import * as React from 'react';
import { Button } from '../Button';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
export var PopoverCloseButton = function PopoverCloseButton(_a) {
  var _a$onClose = _a.onClose,
      onClose = _a$onClose === void 0 ? function () {
    return undefined;
  } : _a$onClose,
      props = __rest(_a, ["onClose"]);

  return React.createElement(Button, Object.assign({
    onClick: onClose,
    variant: "plain",
    "aria-label": true
  }, props, {
    style: {
      pointerEvents: 'auto'
    }
  }), React.createElement(TimesIcon, null));
};